module.exports = __webpack_public_path__ + "media/images/challenges/talent-league-iv/paddle-ac9387ffd252bd109df121fd57571f08.svg";